import { gql } from '@apollo/client';

export const GET_ALL_OPP_LINE_ITEM_STATUS = gql`
  query GetAllOpportunityLineItemStatus(
    $criteria: LineItemStatusCriteriaInput!
    $searchFields: FindLineItemStatusInput
  ) {
    GetAllOpportunityLineItemStatus(Criteria: $criteria, SearchFields: $searchFields) {
      total
      results {
        id
        company {
          id
          name
        }
        data {
          id
          name
          boolean
        }
      }
    }
  }
`;
